import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDirectExpenseLedger,
  fetchDirectExpenseAccountsBySearch,
} from "./DirectExpenseLedgerThunk";

const initialState = {
  list: [],
  directAccounts: [],
  directAccountLoading: false,
  loading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const directExpenseLedgerSlice = createSlice({
  name: "directExpenseLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDirectExpenseLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDirectExpenseLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchDirectExpenseLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchDirectExpenseAccountsBySearch.pending, (state) => {
        state.directAccountLoading = true;
      })
      .addCase(fetchDirectExpenseAccountsBySearch.fulfilled, (state, action) => {
        state.directAccountLoading = false;
        state.directAccounts = action.payload;
      })
      .addCase(fetchDirectExpenseAccountsBySearch.rejected, (state) => {
        state.directAccountLoading = false;
        state.directAccounts = [];
      });
  },
});

export const { setFilters } = directExpenseLedgerSlice.actions;
export default directExpenseLedgerSlice.reducer;
